module.exports = __webpack_public_path__ + "img/clock.f063f62d.svg";